import { render, staticRenderFns } from "./IPsFilters.vue?vue&type=template&id=50978502&"
import script from "./IPsFilters.vue?vue&type=script&lang=js&"
export * from "./IPsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50978502')) {
      api.createRecord('50978502', component.options)
    } else {
      api.reload('50978502', component.options)
    }
    module.hot.accept("./IPsFilters.vue?vue&type=template&id=50978502&", function () {
      api.rerender('50978502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ips/IPsFilters.vue"
export default component.exports